
import "./PropertyStatus.css"
export default function PropertyStatus() {
    return (
        <div className="property-status mt-5 w-fit mx-auto">
            <div className="status-content grid md:grid-cols-3 gap-x-5 md:grid-rows-3 grid-rows-9 md:grid-flow-col place-items-center">
                <div className="fullstack-experience shrink grow basis-0">
                    <div className="sub-title text-center md:text-base text-xl">Client satisfaction</div>
                </div>
                <svg viewBox="0 0 100 100" className="h-60 md:h-auto" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="50" cy="50" r="40" shapeRendering="geometricPrecision" strokeLinecap="round"></circle>
                </svg>
                <span className="counter   mt-[-100%] md:mt-[-190%] text-5xl md:text-2xl font-light">92%</span>


                <div className="years-of-coding shrink grow basis-0">
                    <div className="sub-title text-center md:text-base text-xl">Coding years</div>
                </div>
                <svg viewBox="0 0 100 100" className="h-60 md:h-auto" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="50" cy="50" r="40" shapeRendering="geometricPrecision" strokeLinecap="round"></circle>
                </svg>
                <span className="counter  mt-[-100%] md:mt-[-190%] text-5xl md:text-2xl font-light">6+</span>


                <div className="projects-done shrink grow basis-0">
                    <div className="sub-title text-center md:text-base text-xl">Projects done</div>
                </div>
                <svg viewBox="0 0 100 100" className="h-60 md:h-auto" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="50" cy="50" r="40" shapeRendering="geometricPrecision" strokeLinecap="round"></circle>
                </svg>
                <span className="counter md:mt-[-190%] mt-[-100%] text-5xl md:text-2xl font-light">15</span>


            </div>
        </div>
    )
}